import PROMOTION from '@/api/promotion'

// initial state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
  submitForm ({ commit, state }, payload) {
    return PROMOTION.submitForm(payload)
  },
  checkIfSubmitted ({ commit, state }) {
    return PROMOTION.checkIfSubmitted()
  },
  memberSubmit ({ commit, state }) {
    return PROMOTION.memberSubmit()
  }
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
